import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  GET_PROFILE,
  UPDATE_PROFILE,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PWD,
} from "./actionTypes.js";

import {
  getProfileSuccess,
  getProfileFail,
  updateProfileSuccess,
  updateProfileFail,
  updateUserPasswordSuccess,
  updateUserPasswordFail,
} from "./actions.js"

import {
  profileApi,
  updateProfile,
  updateUserPassword,
} from "./profileApi.js"

function* fetchProfile() {
  try {
    const response = yield call(profileApi)
    yield put(getProfileSuccess(response))
  } catch (error) {
    yield put(getProfileFail(error))
  }
}

function* onUpdateProfile({ payload: profile }) {
  try {
    const response = yield call(updateProfile, profile)
    yield put(updateProfileSuccess(response))
  } catch (error) {
    yield put(updateProfileFail(error))
  }
}

function* onUpdateUserPassword({ payload }) {
  try {
    const response = yield call(updateUserPassword, payload)
    yield put(updateUserPasswordSuccess(response))
  } catch (error) {
    yield put(updateUserPasswordFail(error))
  }
}

function* ProfileSaga() {
  yield takeEvery(GET_PROFILE, fetchProfile)
  yield takeEvery(UPDATE_PROFILE, onUpdateProfile)
  yield takeEvery(UPDATE_USER_PWD, onUpdateUserPassword)
}

export default ProfileSaga
